import { formatInTimeZone } from "date-fns-tz";
const currentTimeZone = "Europe/Amsterdam";

export const localizeTime = (
  dateTime: Date,
  format = "PPP",
  timezone = currentTimeZone,
) => {
  if (dateTime) {
    return formatInTimeZone(dateTime, timezone, format);
  }
};
